import styled from 'styled-components';
import { PopoverIconMixin } from '../../mixins/components/PopoverIconMixin';

/**
 * A wrapper for `Icon` when used within a `Popover`.
 *
 * @since 7.41.0
 */
var PopoverIcon = /*#__PURE__*/styled.div.withConfig({
  displayName: "PopoverIcon",
  componentId: "c11n-8-107-0__sc-c18bd2-0"
})(["", ""], PopoverIconMixin);
PopoverIcon.displayName = 'PopoverIcon';

/** @component */
export { PopoverIcon };